module.exports = __webpack_public_path__ + "static/media/farm-icon.99ae9e9b.png";